import { Component, Input, OnInit } from '@angular/core';
import { MapCommandMenuItem } from '../../types';
import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'dash-gis-sub-menu',
    templateUrl: './map-context-sub-menu.component.html',
    styleUrls: ['./map-context-sub-menu.component.scss'],
    imports: [CdkMenu, CdkMenuItem, MatIcon],
})
export class MapContextSubMenuComponent implements OnInit {
    @Input() menuItems: MapCommandMenuItem[];

    constructor() {}

    ngOnInit(): void {}
}
